var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2802_2751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6406 0.28125H15.9375V0.984375H16.6406V0.28125Z",
    fill: "#C40F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3281 0.28125H17.625V0.984375H18.3281V0.28125Z",
    fill: "#C40F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0156 0.28125H19.3125V0.984375H20.0156V0.28125Z",
    fill: "#C40F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7031 0.28125H21V0.984375H21.7031V0.28125Z",
    fill: "#C40F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73438 26.8594H6.04688V22.5469H5.34375V25.7813C2.34375 23.0625 0.65625 19.2656 0.65625 15.2344C0.703125 7.35938 7.07812 0.9375 14.9531 0.9375V0.28125C6.70312 0.28125 0 6.98438 0 15.2344C0 19.4062 1.73437 23.3438 4.78125 26.2031H1.73438V26.8594Z",
    fill: "#C40F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 14.7656C30 10.5937 28.2656 6.65625 25.2188 3.79688H28.2656V3.14062H23.9531V7.45312H24.6562V4.21875C27.6562 6.9375 29.3437 10.7344 29.3437 14.7656C29.2969 22.6406 22.9219 29.0625 15.0469 29.0625V29.7656C23.2969 29.7187 30 23.0156 30 14.7656Z",
    fill: "#C40F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 29.0625H13.3594V29.7656H14.0625V29.0625Z",
    fill: "#C40F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 29.0625H11.6719V29.7656H12.375V29.0625Z",
    fill: "#C40F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7344 29.0625H10.0312V29.7656H10.7344V29.0625Z",
    fill: "#C40F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04688 29.0625H8.34375V29.7656H9.04688V29.0625Z",
    fill: "#C40F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4531 15C25.4531 9.23437 20.7656 4.54688 15 4.54688C9.23438 4.59375 4.54688 9.23437 4.54688 15C4.54688 20.7656 9.23438 25.4062 15 25.4062C20.7656 25.4062 25.4531 20.7656 25.4531 15ZM15 24.75C9.60938 24.75 5.25 20.3906 5.25 15C5.25 9.60937 9.60938 5.25 15 5.25C20.3906 5.25 24.75 9.60937 24.75 15C24.75 20.3906 20.3906 24.75 15 24.75Z",
    fill: "#C40F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1719 11.3438H12.1875V13.3594H13.875V19.5469H11.7656V21.5625H18.2344V19.5469H16.125V11.3438H16.1719ZM17.5781 20.2969V20.9531H12.4219V20.2969H14.5312V12.7031H12.8437V12.0469H15.4687V20.2969H17.5781Z",
    fill: "#C40F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7185 10.5C15.5623 10.5 16.2185 9.79688 16.2185 9C16.2185 8.15625 15.5154 7.5 14.7185 7.5C13.8748 7.5 13.2185 8.20313 13.2185 9C13.1716 9.79688 13.8748 10.5 14.7185 10.5ZM14.7185 8.10937C15.1873 8.10937 15.5623 8.48438 15.5623 8.95313C15.5623 9.42188 15.1873 9.79687 14.7185 9.79687C14.2498 9.79687 13.8748 9.42188 13.8748 8.95313C13.8748 8.48438 14.2498 8.10937 14.7185 8.10937Z",
    fill: "#C40F11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2802_2751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefPdf);
export default __webpack_public_path__ + "static/media/briefPdf.875cd71fe88ed6702443e2633bd915c3.svg";
export { ForwardRef as ReactComponent };